import script from "./PersonCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonCard.vue?vue&type=script&setup=true&lang=ts"

import "./PersonCard.vue?vue&type=style&index=0&id=c07004ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c07004ce"]])

export default __exports__